"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
function Spinner(_a) {
    var { white, size, color, borderWidth } = _a, rest = __rest(_a, ["white", "size", "color", "borderWidth"]);
    return (react_1.default.createElement(Wrapper, Object.assign({ className: "spinner_wrapper" }, rest),
        react_1.default.createElement(Content, null,
            react_1.default.createElement(StyledSpinner, { size: size, color: white ? "white" : color, borderWidth: borderWidth },
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null)))));
}
Spinner.propTypes = {};
const Content = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const Wrapper = styled_components_1.default.div `
  display: ${({ display = "block" }) => display};
  ${base_ui_components_atoms__atoms_1.common};
`;
const StyledSpinner = styled_components_1.default.div `
  display: inline-block;
  position: relative;
  width: ${({ size }) => size || "30px"};
  height: ${({ size }) => size || "30px"};

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${({ size }) => size || "30px"};
    height: ${({ size }) => size || "30px"};
    margin: 0px;
    border: ${({ borderWidth }) => borderWidth || "4"}px solid ${({ theme, color = "primary" }) => { var _a; return (_a = theme.color[color]) !== null && _a !== void 0 ? _a : color; }};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme, color = "primary" }) => { var _a; return (_a = theme.color[color]) !== null && _a !== void 0 ? _a : color; }} transparent transparent transparent;

    &:nth-child(1) {
      animation-delay: -0.45s;
    }

    &:nth-child(1) {
      animation-delay: -0.3s;
    }

    &:nth-child(1) {
      animation-delay: -0.15s;
    }

    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
exports.default = Spinner;
//# sourceMappingURL=index.js.map